// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"label_labelWrapper__2fd--","required":"label_required__1DxZk"};